var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M14 12a2 2 0 0 1 2 2v4a1 1 0 1 1-2 0v-4H2v4a1 1 0 1 1-2 0v-4a2 2 0 0 1 2-2h12zm4-8a1 1 0 0 1 1 1v2h2a1 1 0 1 1 0 2h-2v2a1 1 0 1 1-2 0V9h-2a1 1 0 1 1 0-2h2V5a1 1 0 0 1 1-1zM8 0a5 5 0 1 1 0 10A5 5 0 0 1 8 0zm0 2a3 3 0 1 0 0 6 3 3 0 0 0 0-6z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }